export default {
    createYourFirstInvoice: 'Create your first invoice',
    information: {
        subtitle:
            'This is a preview of how your information will be displayed on the documents you send to your customers.',
        title: "Great - you're ready to send your first invoice!",
    },
    pageForm: {
        addInvoicingContract: 'Add a separate invoicing contact',
        senderInformationFullButtonLabel: 'Change to Western address format',
        senderInformationFullLabel: 'Show business name and this contact',
        subtitle:
            'We use your business address by default. You can change this anytime later.',
        title: 'Sender information preview',
    },
    senderInformation: {
        businessNameAndThisContact: 'Show business name and this contact',
        businessNameOnly: 'Show business name only',
        delete: 'Delete',
        edit: 'Edit',
        enChangeTo: 'Change to Japanese address format',
        fax: 'FAX {{fax}}',
        jaChangeTo: 'Change to Western address format',
        telephone: 'TEL {{telephone}}',
    },
};
